import Welcome from './welcome';
import DesignProcess from './DesignProcess';
import Tools from './Tools';
import Testimonials from './Testimonials';
import useReveal from '../hooks/useReveal';

function Home() {
  const revealRef = useReveal();

  return (
    <div ref={revealRef}>
      <Welcome />
      <DesignProcess />
      <Tools />
      <div className="reveal-stagger">
        <div className="reveal">
          <Testimonials />
        </div>
      </div>
    </div>
  );
}

export default Home;
